import { Spacing } from '~/types/ThemeTypes'
import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

const newFaxFormStyleParts = [
  'container',
  'toInput',
  'phoneNameText',
  'phoneNumberText',
] as const

const helpers = createMultiStyleConfigHelpers(newFaxFormStyleParts)
export const NewFaxFormStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      alignItems: 'stretch',
      gap: Spacing._2,
    },
    toInput: {
      height: '3.5rem',
    },
    phoneNameText: {
      fontWeight: '900',
      noOfLines: 1,
    },
    phoneNumberText: {
      flexShrink: 0,
    },
  },
})

export const useNewFaxFormStyle = (props?: StyleThemingProps) =>
  mergeMultiStyleConfig(NewFaxFormStyle, props) as MultiStyleType<
    typeof newFaxFormStyleParts
  >
